<template>
    <el-card>
        <div class="work-content">
            <!-- 筛选 -->
            <el-select
                class="mb-10"
                v-model="form.coachId"
                @change="fetchData"
                :placeholder="$t('Common.choose_coach')">
                <input
                    class="croup-coach"
                    type="text"
                    v-model="searchText" >
                <el-option
                    v-for="item in filterList"
                    :key="item.id"
                    :label="item.nickname"
                    :value="Number(item.id)"
                    :disabled="!item.id">
                </el-option>
            </el-select>
            <!-- 数据 -->
            <div class="work-work">
                <div class="work-setting-info">
                    <div class="work-title">{{ $t('Course.Set_date') }}</div>
                    <div class="work-setting-info-content">
                        <el-date-picker
                            @change="fetchData"
                            class="work-copy-item"
                            ref="picker"
                            style="width: 100%"
                            v-model="form.date"
                            value-format="yyyy-MM-dd"
                            type="date"
                            :placeholder="$t('Common.choose_date2')">
                        </el-date-picker>
                        <!-- 预约时间复制区域 -->
                        <div class="group-data-copy">
                            <div class="flex copy-item items-center justify-between">
                                <p>将</p>
                                <el-date-picker
                                    style="width: 100%"
                                    @change="selectTime"
                                    v-model="copy.srcFrom"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    :placeholder="$t('Common.choose_date2')">
                                </el-date-picker>
                            </div>
                            <div class="flex copy-item items-center justify-between">
                                <p>{{ $t('Reception.Third.zhi') }}</p>
                                <el-date-picker
                                    style="width: 100%"
                                    @change="selectTime"
                                    v-model="copy.srcTo"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    :placeholder="$t('Common.choose_date2')">
                                </el-date-picker>
                            </div>
                            <div class="copy-text">{{ $t('Course.copy') }}</div>
                            <div class="flex copy-item items-center justify-between">
                                <p>从</p>
                                <el-date-picker
                                    @change="selectTime"
                                    style="width: 100%"
                                    v-model="copy.destFrom"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    :placeholder="$t('Common.choose_date2')">
                                </el-date-picker>
                            </div>
                            <div v-if="copy.destFrom" class="copy-text">{{ $t('Reception.Third.zhi') }} {{ copy.toEnd }}</div>
                            <div class="text-center">
                                <el-button
                                    class="text-center"
                                    type="primary"
                                    @click="handlecopy"
                                >{{ $t('Course.copy_button') }}</el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="work-setting-avator">
                    <div class="work-title flex items-center justify-between">
                        <div>{{ $t('Course.ReservTimeSett') }}</div>
                        <div class="flex">
                            <el-button
                                @click="handleAdd('add')"
                                type="primary"
                                icon="el-icon-plus">
                                {{ $t('Course.ReservTime') }}
                            </el-button>
                            <el-button
                                @click="handleAdd('leave')"
                                type="success"
                                icon="el-icon-plus">
                                {{ $t('Course.Temporary_leave') }}
                            </el-button>
                        </div>
                    </div>
                    <div class="work-setting-avator-pic">
                        <el-table
                            :data="tableData"
                            style="width: 100%;"
                            border>
                            <el-table-column prop="type" :label="$t('Sell.TicketPrint.type')"/>
                            <el-table-column prop="timeFrom" :label="$t('Course.starttime')" />
                            <el-table-column prop="timeTo" :label="$t('Course.Endtime')" />
                            <el-table-column prop="city" :label="$t('Common.operating')">
                                <template slot-scope="{row, $index}">
                                    <span
                                        @click="handleDelete(row.id)"
                                        class="delete-work"
                                    >
                                        {{ $t('tooltip.delete') }}
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="work-desc">
                    <div class="work-desc-item">
                        <div class="work-title">{{ $t('Course.coach_can_private') }}</div>
                        <div v-if="lessonsList.length" class="work-workship">
                            <div
                                v-for="(i, index) in lessonsList"
                                :key="index">
                                {{ i }}
                            </div>
                        </div>
                        <div v-if="!lessonsList.length" class="work-workship">
                            {{ $t('Course.coach_no_privte') }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 添加上课时间 -->
            <add-work-time ref="add" @fetchData="fetchData" />

        </div>
    </el-card>
</template>

<script>
import { Tabs, TabPane, DatePicker, Radio } from 'element-ui';
import timeMixin from '@/mixins/timeMixin.js';
import filterRole from '@/mixins/filterRole.js';
import AddWorkTime from '@/components/Dialog/WorktimeSetting/AddWorkTime';

export default {
    components: {
        ElTabs: Tabs,
        ElTabPane: TabPane,
        ElRadio: Radio,
        AddWorkTime,
        ElDatePicker: DatePicker,
    },
    mixins: [timeMixin, filterRole],
    props: ['activeName'],
    data() {
        return {
            form: {
                coachId: null,
                date: new Date(),
            },
            coachs: [],
            searchText: '',
            tableData: [],
            lessonsList: [],
            copy: {
                coachId: null,
                srcFrom: null,
                srcTo: null,
                destFrom: null,
                toEnd: null,
            },
        };
    },
    created() {
        if (this.activeName === 'fifth') this.fetchCoach();
    },
    watch: {
        'activeName'(val) {
            if (val === 'fifth') this.fetchCoach();
        },
    },
    computed: {
        filterList() {
            if (!this.searchText) return this.coachs;
            const arr = this.coachs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);

            return arr.length ? arr : [{id: null, nickname: this.$t('Common.data_not_found')}];
        },
    },
    methods: {
        filterTime(date) {
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) month = `0${month}`;
            if (day < 10) day = `0${day}`;
            return `${year}-${month}-${day}`;
        },
        async fetchCoach() {
            const ids = [7, 8];
            this.coachs = await this.filterRole(null, ids);
            const arr = this.coachs;
            if (this.$$filterPermission('课程-教练工作时间设置-仅查看自己')
            && !this.$$filterPermission('课程-教练工作时间设置-可查看全部')) {
                this.coachs = [];
                const userInfo = vm.$store.state.my;
                let item = {
                    id: userInfo.id,
                    nickname: userInfo.nickname,
                };
                this.coachs.push(item);
            }
            // 初始化
            this.form.coachId = this.form.coachId || this.coachs[0].id;
            const arrCoachIds = [];
            for(var i = 0; i < arr.length; i++) {
                arrCoachIds.push(arr[i].id);
            }
            if (arrCoachIds.includes(this.coachs[0].id)) this.fetchData();
        },
        async fetchData() {
            if (!this.form.date.length) {
                this.form.date = this.filterTime(new Date(this.form.date));
            }
            this.copy.srcFrom = this.form.date;
            this.copy.srcTo = this.form.date;
            this.copy.coachId = this.form.coachId;
            await API.get('lesson/coach/time', {
                params: this.form,
            }).then(res => {
                this.tableData = res;
            });
            this.fetchList();
        },
        fetchList() {
            API.get('lesson/coach/time/lesson', {
                params: {
                    coachId: this.form.coachId,
                },
            }).then(res => {
                this.lessonsList = res;
            });
        },
        handleAdd(type) {
            const coach = this.coachs.find(el => el.id === this.form.coachId);
            const date = this.form.date;
            this.$refs.add.open(coach, date, type);
        },
        handleDelete(id) {
            $ele.$confirm(this.$t('Course.confirm_delthis'), this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                API.delete(`lesson/coach/time/${id}`).then(() => {
                    $ele.$message.success(this.$t('Message.delete_success'));
                    this.fetchData();
                });
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
        // copy
        selectTime() {
            let total;
            const start = new Date(this.copy.srcFrom).getTime();
            const end = new Date(this.copy.srcTo).getTime();
            if (start - end > 0) total = this.getTotal(end, start);
            else total = this.getTotal(start, end);
            const day = this.AddWeeks(new Date(this.copy.destFrom), total);
            this.copy.toEnd = this.filterTime(day);
        },
        handlecopy() {
            const form = Object.assign({}, this.copy);
            if (!form.destFrom) return $ele.$message(this.$t('Common.choose_date'));
            delete form.toEnd;

            const msg = `是否将 ${form.srcFrom} ~ ${form.srcTo} 的全部时间设定，
            复制至 ${form.destFrom} ~ ${this.copy.toEnd}？`;
            $ele.$confirm(msg, '工作时间复制确认', {
                confirmButtonText: '确定复制',
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                if (this.$$filterPermission('课程-教练工作时间设置-添加/复制/删除私教上课时间')) {
                    API.put('lesson/coach/time/copy', form).then(() => {
                        $ele.$message.success(this.$t('Message.copy_success'));
                        this.form.date = new Date();
                        this.fetchData();
                    });
                } else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
    },
};
</script>

<style lang="scss">
.work-content {
    color: #666;
}
.work-form {
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 15px;
}
.work-store {
    width: 200px;
}
.label {
    white-space: nowrap;
    margin: 0 10px 0 0;
    font-size: 14px;
}
.label-2 {
    white-space: nowrap;
    margin: 0 10px 0 20px;
    font-size: 14px;
}
.work-nickname {
    width: 375px;
}
.work-setting-info,
.work-setting-avator {
    width: 25%;
    margin-right: 1%;
    border: 1px solid #e6e6e6;
    display: inline-block;
    vertical-align: text-top;
}
.work-setting-avator {
    width: 53%;
}
.work-desc {
    width: 20%;
    display: inline-block;
    vertical-align: text-top;
}
.work-desc-item {
    margin-bottom: 15px;
    border: 1px solid #e6e6e6;
}
.work-title {
    font-size: 13px;
    background: #fafafa;
    padding: 18px 20px;
    border-bottom: 1px solid #e6e6e6;
}
.work-setting-info-content {
    padding: 20px 10px;
    // div {
    //     font-size: 12px;
    // }
    // .work-copy-item {
    //     margin: 0 20px 15px;

    //     p {
    //         margin-right: 12px;
    //     }

    //     &:first-child {
    //         margin-top: 15px;
    //     }
    // }
    // button {
    //     margin-bottom: 15px;
    // }
    // .copy-text {
    //     margin-bottom: 15px;
    //     margin-left: 25px;
    // }
}
.delete-work {
    color: #05abef;
    cursor: pointer;
}
.work-setting-avator-pic {
    width: 100%;
    padding: 15px;
}
.work-workship {
    padding: 15px;
    font-size: 12px;

    div {
        margin: 0 0 10px 0;

        &:last-child {
            margin: 0;
        }
    }
}
</style>
